export default __webpack_public_path__ + "static/media/9.cfc4e761.png";